import React from 'react';
import { HeaderMainFooterLayout } from '@/modules/base';
import DataCenter from '@/modules/data/DataCenter';
import { isEmpty, some } from 'lodash';
import { useInteractionState } from '@/hooks';
import {
  ContactComponent,
  DiscountComponent,
  HomeComponent,
  FooterComponent,
  MapComponent,
  MediaComponent,
  NavigationComponent,
  SpecialityComponent,
} from '@/modules/components';
import { MenuItem } from '@/type';

export const MainPageComponent = () => {
  const { management, menus, products } = useInteractionState();

  const hasMenu = (items: MenuItem[], menuKey: string) => {
    return some(items, (it: MenuItem) => it.key === menuKey && it.show);
  };

  return (
    <HeaderMainFooterLayout
      header={<NavigationComponent menuItems={menus ?? []} />}
      main={
        <div className="content">
          {hasMenu(menus, DataCenter.HOME_MENU) && <HomeComponent />}
          {hasMenu(menus, DataCenter.SPECIALITY_MENU) && !isEmpty(products) && (
            <SpecialityComponent products={products} />
          )}
          {hasMenu(menus, DataCenter.MEDIA_MENU) && <MediaComponent />}
          {hasMenu(menus, DataCenter.DISCOUNT_MENU) && !isEmpty(products) && (
            <DiscountComponent products={products} />
          )}
          {hasMenu(menus, DataCenter.MAP_MENU) && <MapComponent />}
          {hasMenu(menus, DataCenter.CONTACT_MENU) && (
            <ContactComponent
              email={management?.company?.email ?? ''}
              telephone={management?.company?.telephone ?? ''}
              emailDisable={management?.email_disable ?? false}
            />
          )}
        </div>
      }
      footer={<FooterComponent />}
    />
  );
};
